<template>
  <div>
    <van-dialog v-model="DialogShow" :title="isAdd?'添加申领合同':'修改申领合同'" width="95%" class="editClue" :beforeClose="beforeClose" show-cancel-button>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group v-for="(item,index) in applyArr" :key="index">
          <van-field readonly clickable v-model="item.companyName" @click="showPicker2(index)" label="公司名称" :rules="[{ required: true }]" placeholder="请选择公司" required />
          <van-field readonly clickable v-model="item.serviceTypeName" @click="showPicker(index)" label="业务类型" :rules="[{ required: true }]" placeholder="请选择业务类型" required />
          <van-field v-if="item.chooseType != '数字技术类'" readonly clickable v-model="item.contPartnerTypeName" @click="item.serviceTypeName?showPicker3(index):''" label="合作类型" :rules="[{ required: true }]" placeholder="请选择合作类型" required />
          <van-field v-model="item.applyCount" label="申请份数" type="digit" placeholder="请输入申请份数" maxlength="2" :rules="[{ required: true,pattern: /^([1-9]|[12][0-9]|30)$/, message: '一次最多申领30份！'}]" required />
          <van-field v-model="item.remark"
              autosize
              label="申请说明"
              placeholder="请输入说明"
              type="textarea"
              show-word-limit />
          <div class="link" v-if="isAdd">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addMore">添加更多</van-button>
            <van-button class="linkaddBtn" v-if="index!=0" round block type="warning" native-type="button" size="small" @click="deleteT(index)">删除</van-button>
          </div>
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-popup v-model="showServiceTypeTree" position="bottom">
      <van-cascader title="请选择业务类型" :options="serviceTypeTreeList" :field-names="fieldNames" @close="showServiceTypeTree = false" @change="serviceTypeChange" @finish="onFinishServiceTypeTree" />
    </van-popup>

    <van-popup v-model="showDeptTree" position="bottom">
      <van-picker title="请选择公司" show-toolbar :columns="deptTreeList" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>

    <van-popup v-model="showContPartnerType" position="bottom">
      <van-picker title="请选择合作类型" show-toolbar :columns="contPartnerTypeList" @confirm="contPartnerTypeConfirm" @cancel="contPartnerTypeCancel" />
    </van-popup>
  </div>
</template>
<script>
import { addApplyCont, modifyApplyCont } from '@/api/cont/contract'
import { Toast, Cascader } from 'vant'
import { businessTypeList, companyList } from '@/api/admi/dept'
import { getDicts } from '@/api/system/dict/data'

export default {
  name: 'DialogApply',
  components: {
    vanCascader: Cascader
  },
  props: {
    show: Boolean,
    isAdd: Boolean,
    modifyObj: Object
    // deptTreeOptions:Array
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    contractType: {
      handler(val, oldVal) {
        this.form.contractType = val
      }
    },
    modifyObj: {
      handler(val, oldVal) {
        if (val.contPartnerType === '' || val.contPartnerType === null) {
          val.chooseType = '数字技术类'
        } else {
          val.chooseType = val.serviceTypeName.substring(3, 8)
          val.contPartnerTypeName = this.formatHandel('contPartnerType', val.contPartnerType)
        }
        this.applyArr[0] = val
      //  console.log("val:"+JSON.stringify(val));
      }
    }
    // deptTreeOptions:{
    //   handler(val, oldVal) {
    //     this.deptTreeList = this.getData(val)
    //   //  console.log("val:"+JSON.stringify(val));
    //   }
    // }
  },
  data() {
    return {
      DialogShow: this.show,
      applyArr: [
        {
          contPartnerType: '',
          companyName: '',
          companyId: '',
          serviceTypeName: '',
          serviceTypeId: '',
          applyCount: '',
          remark: '',
          chooseType: ''
        }
      ],
      // 选择业务类型弹出框
      showServiceTypeTree: false,
      showDeptTree: false,
      showContPartnerType: false,
      contPartnerTypeList: [],
      serviceTypeTreeList: [],
      deptTreeList: [],
      fieldNames: {
        text: 'businessTypeName',
        value: 'businessTypeId'
      },
      // picker: {
      //   // visible: false,
      //   title: "",
      //   columns: []
      // },
      options: {
        // 业务类型树选项
        businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
        contPartnerTypeOptions: []
      },
      form: {
        serviceTypeName: '',
        applyCount: '',
        remark: ''
      },
      index: null
    }
  },
  async created() {
    if (!this.isAdd) {
      await getDicts('cont_partner_type').then(res => {
        console.log(res)
        let item = {}
        this.options.contPartnerTypeOptions = res.data
        this.contPartnerTypeList = this.options.contPartnerTypeOptions.map((ele) => item = { id: ele.dictValue, text: ele.dictLabel })
      })
    }
  },
  methods: {
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    pickerConfirm(value) {
      console.log(value)
      this.applyArr[this.index].companyName = value.text
      this.applyArr[this.index].companyId = value.id
      this.showDeptTree = false
    },
    contPartnerTypeConfirm(value, key) {
      this.applyArr[this.index].contPartnerType = value.id
      this.applyArr[this.index].contPartnerTypeName = value.text
      this.showContPartnerType = false
    },
    contPartnerTypeCancel() {
      this.showContPartnerType = false
    },
    pickerCancel() {
      this.showDeptTree = false
    },
    // 打开联级选择框
    async showPicker(index) {
      if (this.serviceTypeTreeList.length == 0) {
        // 获取业务类型
        await businessTypeList({ pageNum: 1, pageSize: 500, dataTag: 0 }).then((response) => {
          if (response.code === 200) {
            this.serviceTypeTreeList = this.getData(response.rows)
          }
        })
      }
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.showServiceTypeTree = true
    },
    // 打开联级选择框
    async showPicker2(index) {
      if (this.deptTreeList.length == 0) {
        // 获取公司信息
        await companyList().then((response) => {
          let item = {
            id: '',
            text: ''
          }
          this.deptTreeList = response.rows.map((ele) => item = { id: ele.companyId, text: ele.companyName })
        })
      }
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      // this.deptTreeList = this.deptTreeList.map((ele) => ele.companyName);
      this.showDeptTree = true
    },
    async showPicker3(index) {
      // if (this.contPartnerTypeList.length == 0) {
      // 我方主体地址
      await getDicts('cont_partner_type').then(res => {
        console.log(res)
        let item = {}
        console.log(this.applyArr[index].chooseType)
        if (this.applyArr[index].chooseType == '数字营销运') {
          this.options.contPartnerTypeOptions = res.data.filter((item) => item.dictLabel.substring(0, 5) == '效果运营类')
        } else if (this.applyArr[index].chooseType == '数字媒介类') {
          this.options.contPartnerTypeOptions = res.data.filter((item) => item.dictLabel.substring(0, 5) == '数字媒介类')
        }
        // this.options.contPartnerTypeOptions = res.data
        this.contPartnerTypeList = this.options.contPartnerTypeOptions.map((ele) => item = { id: ele.dictValue, text: ele.dictLabel })
      })
      // }
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.showContPartnerType = true
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    async beforeClose(type, done) {
      if (type === 'confirm') {
        if (this.isAdd) {
          try {
            await this.$refs.form.validate()
            await addApplyCont(this.applyArr)
            await this.reset()
              .then(() => {
                Toast.success('添加成功')
                setTimeout(() => {
                  this.$emit('beforeClose', '')
                }, 500)
              }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        } else {
          try {
            await this.$refs.form.validate()
            await modifyApplyCont(this.applyArr[0])
            await this.reset()
              .then(() => {
                Toast.success('修改成功')
                setTimeout(() => {
                  this.$emit('beforeClose', '')
                }, 500)
              }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        }
      } else {
        done()
        this.$emit('handleAddContractCancel')
      }
    },
    // 清空表单
    async reset() {
      this.applyArr = [{
        serviceTypeName: '',
        applyCount: '',
        remark: ''
      }]
    },
    serviceTypeChange(obj) {
      this.applyArr[this.index].contPartnerType = null
      this.applyArr[this.index].contPartnerTypeName = null
      if (obj.selectedOptions[2]) {
        if (obj.selectedOptions[2].businessTypeName == '效果运营类') {
          this.applyArr[this.index].chooseType = '数字营销运'
          this.applyArr[this.index].serviceTypeId = obj.value
          this.applyArr[this.index].serviceTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
        }
      }
    },
    onFinishServiceTypeTree(obj) {
      this.applyArr[this.index].contPartnerType = null
      this.applyArr[this.index].contPartnerTypeName = null
      if (obj.selectedOptions[obj.selectedOptions.length - 1].remark) {
        if (obj.selectedOptions[obj.selectedOptions.length - 1].remark.length == 2) {
          this.applyArr[this.index].chooseType = '数字技术类'
        } else {
          this.applyArr[this.index].chooseType = obj.selectedOptions[1].businessTypeName.substring(0, 5)
        }
      }
      // console.log(obj.selectedOptions[obj.selectedOptions.length - 1])
      this.applyArr[this.index].serviceTypeId = obj.value
      this.applyArr[this.index].serviceTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      this.showServiceTypeTree = false
      // this.form.deptId = obj.value;
      // this.form.deptName = obj.selectedOptions.map((option) => option.text).join("/");
    },
    addMore() {
      const peo = {
        companyName: '',
        companyId: '',
        serviceTypeName: '',
        serviceTypeId: '',
        applyCount: '',
        remark: ''
      }
      this.applyArr.push(peo)
    },
    deleteT(item) {
      this.applyArr.splice(item, 1)
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
/deep/.van-dialog{
  height: 80%;
}
.editClue /deep/.van-dialog__content {
  height: 80%;
}
.link{
  height: 80px;
  margin-bottom: 60px;
}
</style>
